import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Animations {
    static init() {
        gsap.registerPlugin(ScrollTrigger);

        this.header();
        this.headerCol();
        this.headerContact();
        this.headerLabel();
        this.headerToolbox();
        this.home();
        this.sectionContent();

        this.parallax('.strategie__col--images', '.strategie__figure--right', 2.5);
        this.parallax('.equipe', '.equipe__figure', 4);
        this.parallax('.cols', '.cols__item--parallax', 8);
    }

    static header() {
        const header = document.querySelector('.header');
        if (header && !header.classList.contains('header--col')) {
            gsap.to(
                header.querySelectorAll('.title--h1, p'),
                {
                    y: 0,
                    opacity: 1,
                    duration: 1.2,
                    ease: 'power4.out',
                    stagger: 0.1,
                }
            );
        }
    }

    static headerCol() {
        const header = document.querySelector('.header');
        if (header && header.classList.contains('header--col')) {
            gsap.to(
                header.querySelector('.header__figure'),
                {
                    y: 0,
                    opacity: 1,
                    duration: 1.2,
                    ease: 'power4.out',
                    delay: 0.1,
                }
            );

            gsap.to(
                header.querySelector('.header__image'),
                {
                    scale: 1,
                    duration: 1.2,
                    ease: 'power4.out'
                }
            );

            gsap.to(
                header.querySelectorAll('.header__content .title, .header__content p'),
                {
                    y: 0,
                    opacity: 1,
                    duration: 1.45,
                    ease: 'power4.out',
                    delay: 0.3,
                    stagger: 0.1,
                }
            );
        }
    }

    static headerContact() {
        if(!document.body.classList.contains('page-template-page-contact')) {
            return false;
        }

        const items = gsap.utils.toArray('.header .list__item');
        gsap.to(
            items,
            {
                y: 0,
                opacity: 1,
                duration: 1.2,
                ease: 'power4.out',
                stagger: 0.1,
                delay: 0.2,
            }
        );
    }

    static headerLabel() {
        if(!document.body.classList.contains('single-labels')) {
            return false;
        }

        const header = document.querySelector('.header');
        gsap.to(
            header.querySelector('.header__image'),
            {
                scale: 1,
                filter: 'blur(0px)',
                duration: 1.2,
                ease: 'power4.out',
            }
        );

        gsap.to(
            header.querySelector('.header__link'),
            {
                y: 0,
                opacity: 1,
                duration: 1.2,
                ease: 'power4.out',
                delay: 0.1,
            }
        );

        gsap.to(
            document.querySelector('.section .title--h1'),
            {
                y: 0,
                opacity: 1,
                duration: 1.2,
                ease: 'power4.out',
                delay: 0.4,
            }
        );
    }

    static headerToolbox() {
        if(!document.body.classList.contains('single-toolbox')) {
            return false;
        }

        const header = document.querySelector('.header');
        gsap.to(
            header.querySelector('.header__image'),
            {
                scale: 1,
                filter: 'blur(0px)',
                duration: 1.2,
                ease: 'power4.out',
            }
        );

        gsap.to(
            document.querySelector('.section .title--h1'),
            {
                y: 0,
                opacity: 1,
                duration: 1.2,
                ease: 'power4.out',
                delay: 0.4,
            }
        );
    }

    static home() {
        if(document.body.classList.contains('home')) {
            const header = document.querySelector('.header');
            gsap.to(
                header.querySelector('.header__content .title--h3'),
                {
                    y: 0,
                    opacity: 1,
                    duration: 1.2,
                    ease: 'power4.out',
                    delay: 0.1,
                }
            );
    
            gsap.to(
                document.querySelector('.header__content .title--h1'),
                {
                    y: 0,
                    opacity: 1,
                    duration: 1.2,
                    ease: 'power4.out',
                    delay: 0.2,
                }
            );
            
            const elts = gsap.utils.toArray(`
                .push__item,
                .push__item > img,
                .push__title,
                .push__item svg
            `);

            gsap.from(
                elts,
                {
                    scrollTrigger: {
                        trigger: document.querySelector('.push__wrapper'),
                        start: 'top 80%'
                    },
                    y: 40,
                    opacity: 0,
                    duration: 1.2,
                    ease: 'power4.out',
                    stagger: 0.1,
                }
            );
        }
    }

    static sectionContent() {
        const elts = gsap.utils.toArray(`
            .section p,
            .section h2,
            .section h3,
            .section h4,
            .section .cta,
            .section iframe,
            .section ul li,
            .section ol li,
            .section .youtube_player,
            .mission__pictoFigure,
            .presentation__logo,
            .introduction__picto,
            .textlogo__image,
            .textlogo__picto,
            .document__title,
            .document__image,
            .document__item svg,
            .file__item,
            .icon__image,
            .download__title,
            .team__content a,
            .job__item
        `);

        elts.forEach((elt) => {
            gsap.from(
                elt,
                {
                    scrollTrigger: {
                        trigger: elt,
                        start: 'top 80%'
                    },
                    y: 40,
                    opacity: 0,
                    duration: 1.2,
                    ease: 'power4.out',
                }
            );
        });

        const staggers = gsap.utils.toArray('.page__item .page__image, .pages__item .pages__image, .post-type-archive-toolbox .tab__wrapper');
        gsap.from(
            staggers,
            {
                scrollTrigger: {
                    trigger: staggers,
                    start: 'top 80%'
                },
                y: 40,
                opacity: 0,
                duration: 1.2,
                ease: 'power4.out',
                stagger: 0.1,
                onComplete: function() {
                    gsap.set(this.targets(), {
                        clearProps: 'all',
                    });
                }
            }
        );

        if(document.body.classList.contains('post-type-archive-labels')) {
            const labels = gsap.utils.toArray('.label .label__item');
            gsap.from(
                labels,
                {
                    scrollTrigger: {
                        trigger: document.querySelector('.label'),
                        start: 'top 80%'
                    },
                    y: 40,
                    opacity: 0,
                    duration: 1.2,
                    ease: 'power4.out',
                    stagger: 0.1,
                }
            );
        }
    }

    static parallax(elt, children, offset) {
        if(window.innerWidth > 1023) {
            const containers = document.querySelectorAll(elt);
            if(containers) {
                containers.forEach((container) => {
                    gsap.to(
                        container.querySelector(children),
                        {
                            scrollTrigger: {
                                trigger: container,
                                start: 'top 80%',
                                end: `+=${window.innerHeight}px`,
                                scrub: true,
                            },
                            y: container.offsetHeight / offset * -1,
                        }
                    );
                });
            }
        }
    }
}